// The theme makes every TextField a full-width, 56px form field with !important rules
// (theme/overrides/MuiTextField.js, MuiOutlinedInput.js). Its border-box sizing also squeezes the
// 33px of padding into MUI's 1.4375em input height, which clips the text of a native date input.
// Report filters sit in a row, so these fields undo those rules for themselves only.
const compactFieldSx = {
  width: 'auto !important',
  minWidth: '0 !important',
  marginTop: '0 !important',
  marginBottom: '0 !important',
  // MUI's small field height, so dates and an Autocomplete beside them line up.
  '& .MuiOutlinedInput-root': {
    minHeight: '40px !important',
    width: 'auto !important',
  },
  '& .MuiOutlinedInput-input': {
    padding: '8.5px 14px !important',
    boxSizing: 'content-box !important',
    width: 'auto !important',
  },
};

export default compactFieldSx;
